import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masterr',
  templateUrl: './masterr.component.html',
  styleUrls: ['./masterr.component.scss']
})
export class MasterrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
